<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-select v-model="queryForm.category" :items="categorys" item-text="label" item-value="value" label="类别"
          no-data-text="无" clearable dense outlined hide-details :menu-props="{ bottom: true, offsetY: true }">
          <template v-slot:selection="{ item }">
            <a-tag :color="item.color">
              {{ item.text }}
            </a-tag>
          </template>
          <template v-slot:item="{ item }">
            <a-tag :color="item.color">
              {{ item.text }}
            </a-tag>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" dark tile @click="showadd()">
            <v-icon small>mdi-plus</v-icon> 新增
          </v-btn>
          <v-btn color="cyan" dark tile @click="() => $refs.uploadRef.showupload()">
            <v-icon small>mdi-upload</v-icon> 批量导入
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" :key="index" @click="limit = item.value">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="postline" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="vehicle_type" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="driver" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="category" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <template v-for="item in categorys">
              <a-tag v-if="item.value === record.category" :key="item.value" :color="item.color">
                {{ item.text }}
              </a-tag>
            </template>
          </template>
        </template>
        <template slot="amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="date" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="remark" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="evidence" slot-scope="text, record">
          <a v-if="!record._isSummary && record.evidence" :href="record.evidence" target="_blank">
            查看
          </a>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space v-if="!record._isSummary">
            <a-button type="link" size="small" @click="showedit(record)">
              <a-icon type="edit" /> 编辑
            </a-button>
            <a-popconfirm title="删除该条考核记录?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <a-button type="link" size="small" style="color:#ff4d4f">
                <a-icon type="delete" /> 删除
              </a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <!-- 新增/编辑弹窗 -->
    <v-dialog v-model="model" persistent max-width="800px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ title }}
            <v-icon @click="() => model = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="form.postline" :rules="[vrules.required]" outlined dense hide-details>
                    <template v-slot:label>
                      线路 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select v-model="form.vehicle_type" :items="vehicle_types" outlined dense hide-details
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无">
                    <template v-slot:label>
                      车型
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.vehicle_number" outlined dense hide-details>
                    <template v-slot:label>车牌号</template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.driver" outlined dense hide-details>
                    <template v-slot:label>司机</template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select v-model="form.category" :items="categorys" :rules="[vrules.required]" outlined dense
                    hide-details :menu-props="{ bottom: true, offsetY: true }" no-data-text="无">
                    <template v-slot:label>
                      考核类别<span class="red--text">*</span>
                    </template>
                    <template v-slot:selection="{ item }">
                      <a-tag :color="item.color">
                        {{ item.text }}
                      </a-tag>
                    </template>
                    <template v-slot:item="{ item }">
                      <a-tag :color="item.color">
                        {{ item.text }}
                      </a-tag>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model.number="form.amount" :rules="[vrules.required]" type="number" outlined dense
                    hide-details>
                    <template v-slot:label>
                      扣罚金额（元）<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="false"
                    :return-value.sync="form.date" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.date" :rules="[vrules.required]" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" outlined dense hide-details>
                        <template v-slot:label>日期<span class="red--text">*</span></template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.date" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.date_menu.save(form.date); date_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" outlined rows="2" dense>
                    <template v-slot:label>备注</template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" :disabled="!valid" @click="save">提交</v-btn>
            <v-btn tile @click="() => model = false">取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <UploadTask ref="uploadRef" modelTitle="导入考核异常记录"
      :alertText="`上传Excel文件需包含 <span class='error--text'>线路</span>、<span class='error--text'>车型</span>、<span>车牌号</span>、<span>司机</span>、<span class='error--text'>考核类别</span>、<span class='error--text'>扣罚金额</span>、<span class='error--text'>日期</span>、<span>备注</span>、<span>考核依据URL</span> 字段。考核类别：<span class='error--text'>1无GPS、2晚靠台、3到位不及时、4安全类、5其他</span>，日期格式：<span class='error--text'>YYYY-MM-DD</span>。`"
      uploadType="waybillcheckexception" :templateFile="templateFile" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "ManageException",
  components: { UploadTask },
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      date_menu: false,
      queryForm: {
        start_day: "",
        end_day: "",
        category: null,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      categorys: [],
      vehicle_types: [],
      headers: [
        { title: '序号', dataIndex: 'index', scopedSlots: { customRender: 'index' }, width: 70, align: 'center' },
        { title: '线路', dataIndex: 'postline', scopedSlots: { customRender: 'postline' }, width: 160, align: 'center' },
        { title: '车型', dataIndex: 'vehicle_type', scopedSlots: { customRender: 'vehicle_type' }, width: 110, align: 'center' },
        { title: '车牌号', dataIndex: 'vehicle_number', scopedSlots: { customRender: 'vehicle_number' }, width: 120, align: 'center' },
        { title: '司机', dataIndex: 'driver', scopedSlots: { customRender: 'driver' }, width: 100, align: 'center' },
        { title: '考核类别', dataIndex: 'category', scopedSlots: { customRender: 'category' }, width: 120, align: 'center' },
        { title: '扣罚金额（元）', dataIndex: 'amount', scopedSlots: { customRender: 'amount' }, width: 130, align: 'center' },
        { title: '日期', dataIndex: 'date', scopedSlots: { customRender: 'date' }, width: 120, align: 'center' },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 200, align: 'center' },
        { title: '考核依据', dataIndex: 'evidence', scopedSlots: { customRender: 'evidence' }, width: 100, align: 'center' },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 140, align: 'center' },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      model: false,
      title: '',
      form: {},
      valid: true,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      templateFile: {
        url: `${process.env.BASE_URL}template/考核异常导入模板.xlsx`,
        name: '考核异常导入模板.xlsx',
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 200), 0);
    },
    summaryList() {
      if (!this.list || this.list.length === 0) {
        return [];
      }
      const sum = (key) => this.list.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
      return [
        {
          _id: 'summary',
          _isSummary: true,
          index: '合计',
          amount: Math.round(sum('amount') * 100) / 100,
        },
        ...this.list,
      ];
    },
  },
  watch: {
    page() { this.getdata(); },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = () => {
      this.height = window.innerHeight - 300;
    };
  },
  activated() {
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      start_day,
      end_day,
      category: null,
    };
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/checkexception/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;
          this.categorys = res.data.categorys;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: '',
        postline: '',
        vehicle_type: null,
        vehicle_number: '',
        driver: '',
        category: null,
        amount: '',
        date: this.$moment().format('YYYY-MM-DD'),
        remark: '',
      };
      this.title = '新增考核异常';
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        postline: item.postline,
        vehicle_type: item.vehicle_type,
        vehicle_number: item.vehicle_number,
        driver: item.driver,
        category: item.category,
        amount: item.amount,
        date: item.date,
        remark: item.remark,
      };
      this.title = '编辑考核异常';
      this.model = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/checkexception/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    async doupload(file) {
      this.$toast.loading({ message: "" });
      const slicefiles = this.$utils.sliceFile(file.size);
      const faid = this.$utils.uuid();
      for (let j = 0; j < slicefiles.length; j++) {
        const slicefile = slicefiles[j];
        const formData = new FormData();
        if (slicefile.chunks > 1) {
          formData.set("file", file.slice(slicefile.from, slicefile.to));
        } else {
          formData.set("file", file);
        }
        formData.set("faid", faid);
        formData.set("chunk", slicefile.chunk);
        formData.set("chunks", slicefile.chunks);
        formData.set("originalname", file.name);
        formData.set("exceptionid", this.exceptionid);
        try {
          let res = await this.$api.doUpload("/waybill/checkexception/plupload", formData);
          if (res.code === 0) {
            if (slicefile.chunk + 1 === slicefile.chunks) {
              this.$toast.clear();
            }
          } else {
            this.$toast.clear();
            this.$alert(res.msg);
            throw new Error(res.msg);
          }
        } catch (e) {
          this.$toast.clear();
          console.error(e);
          throw e;
        }
      }
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/checkexception/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) this.getdata();
        else this.$alert(res.msg);
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
}
</style>
